let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4UjsP")).then(() => parcelRequire('8SHH6'));